import { render, staticRenderFns } from "./changelog.vue?vue&type=template&id=83bd04d8&lang=html&"
import script from "./changelog.vue?vue&type=script&lang=js&"
export * from "./changelog.vue?vue&type=script&lang=js&"
import style0 from "./changelog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports